module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_is-object.js
// module id = 55
// module chunks = 0